import { motion } from "framer-motion";
import { fadeInUp } from "../utils/motion";

function SectionTitle({ eyebrow, title, subtitle }) {
  return (
    <motion.div
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      className="mb-10"
    >
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-cyan-300 sm:text-sm sm:tracking-[0.2em]">
        {eyebrow}
      </p>
      <h2 className="text-2xl font-bold leading-tight text-white sm:text-4xl">
        {title}
      </h2>
      <p className="mt-3 max-w-2xl text-sm leading-7 text-blue-100/80 sm:text-lg">
        {subtitle}
      </p>
    </motion.div>
  );
}

export default SectionTitle;
